import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setSfChatIsOpen as setChatOpenStatus } from '../../../api/sfChat/sfChatAction';
import { createSfScriptTag } from '../../../utils/shared/sfChat.utils';

const SfChatWrapper = ({ setSfChatIsOpen }) => {
    useEffect(() => {
        createSfScriptTag(setSfChatIsOpen);
        const handleBeforePrint = () => {
            const sfChatIcon = document.getElementById('embedded-messaging');
            if (sfChatIcon) {
                sfChatIcon.style.display = 'none';
            }
        };

        const handleAfterPrint = () => {
            const sfChatIcon = document.getElementById('embedded-messaging');
            if (sfChatIcon) {
                sfChatIcon.style.display = 'block';
            }
        };

        window.onbeforeprint = handleBeforePrint;
        window.onafterprint = handleAfterPrint;

        return () => {
            window.onbeforeprint = null;
            window.onafterprint = null;
        };
    }, []);

    return null;
};

SfChatWrapper.propTypes = {
    setSfChatIsOpen: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
    setSfChatIsOpen: shouldOpen => dispatch(setChatOpenStatus(shouldOpen)),
});

export default connect(null, mapDispatchToProps)(SfChatWrapper);
